var map = {
	"./butter-caramel-fruit-board.jpg": 3325,
	"./butter-caramel-fruit-slices.jpg": 812,
	"./butter-caramel-fruit-tray.jpg": 4993,
	"./butter-plain-board.jpg": 2591,
	"./butter-plain-slices.jpg": 50,
	"./butter-plain-tray.jpg": 1239,
	"./caramel-board.jpg": 5533,
	"./caramel-cocoa-foil.jpg": 1477,
	"./caramel-cocoa-loaf.jpg": 9957,
	"./caramel-cocoa-slices-cherry.jpg": 9726,
	"./caramel-cocoa-slices-kaju.jpg": 246,
	"./caramel-cocoa-slices-kismis.jpg": 2421,
	"./caramel-cocoa-slices-mixed.jpg": 8576,
	"./caramel-cocoa-slices-none.jpg": 3931,
	"./caramel-cocoa-slices-tuttifrutti.jpg": 7865,
	"./caramel-cocoa-slices-walnut.jpg": 3856,
	"./caramel-foil.jpg": 423,
	"./caramel-fruit-board.jpg": 1784,
	"./caramel-fruit-tray.jpg": 1822,
	"./caramel-loaf.jpg": 6071,
	"./caramel-slices-cherry.jpg": 3628,
	"./caramel-slices-kaju.jpg": 9912,
	"./caramel-slices-kismis.jpg": 4099,
	"./caramel-slices-mixed.jpg": 2878,
	"./caramel-slices-none.jpg": 2241,
	"./caramel-slices-tuttifrutti.jpg": 7583,
	"./caramel-slices-walnut.jpg": 1738,
	"./caramel-tray.jpg": 801,
	"./plain-board.jpg": 7414,
	"./plain-cocoa-foil.jpg": 8692,
	"./plain-cocoa-loaf.jpg": 1216,
	"./plain-cocoa-slices-cherry.jpg": 4549,
	"./plain-cocoa-slices-kaju.jpg": 1677,
	"./plain-cocoa-slices-kismis.jpg": 7670,
	"./plain-cocoa-slices-mixed.jpg": 8629,
	"./plain-cocoa-slices-none.jpg": 5787,
	"./plain-cocoa-slices-tuttifrutti.jpg": 4920,
	"./plain-cocoa-slices-walnut.jpg": 2919,
	"./plain-foil.jpg": 1354,
	"./plain-loaf.jpg": 4305,
	"./plain-slices-cherry.jpg": 2911,
	"./plain-slices-kaju.jpg": 6043,
	"./plain-slices-kismis.jpg": 3256,
	"./plain-slices-mixed.jpg": 8239,
	"./plain-slices-none.jpg": 3954,
	"./plain-slices-tuttifrutti.jpg": 4090,
	"./plain-slices-walnut.jpg": 6957,
	"./plain-tray.jpg": 552,
	"assets/shop/butter-caramel-fruit-board.jpg": 3325,
	"assets/shop/butter-caramel-fruit-slices.jpg": 812,
	"assets/shop/butter-caramel-fruit-tray.jpg": 4993,
	"assets/shop/butter-plain-board.jpg": 2591,
	"assets/shop/butter-plain-slices.jpg": 50,
	"assets/shop/butter-plain-tray.jpg": 1239,
	"assets/shop/caramel-board.jpg": 5533,
	"assets/shop/caramel-cocoa-foil.jpg": 1477,
	"assets/shop/caramel-cocoa-loaf.jpg": 9957,
	"assets/shop/caramel-cocoa-slices-cherry.jpg": 9726,
	"assets/shop/caramel-cocoa-slices-kaju.jpg": 246,
	"assets/shop/caramel-cocoa-slices-kismis.jpg": 2421,
	"assets/shop/caramel-cocoa-slices-mixed.jpg": 8576,
	"assets/shop/caramel-cocoa-slices-none.jpg": 3931,
	"assets/shop/caramel-cocoa-slices-tuttifrutti.jpg": 7865,
	"assets/shop/caramel-cocoa-slices-walnut.jpg": 3856,
	"assets/shop/caramel-foil.jpg": 423,
	"assets/shop/caramel-fruit-board.jpg": 1784,
	"assets/shop/caramel-fruit-tray.jpg": 1822,
	"assets/shop/caramel-loaf.jpg": 6071,
	"assets/shop/caramel-slices-cherry.jpg": 3628,
	"assets/shop/caramel-slices-kaju.jpg": 9912,
	"assets/shop/caramel-slices-kismis.jpg": 4099,
	"assets/shop/caramel-slices-mixed.jpg": 2878,
	"assets/shop/caramel-slices-none.jpg": 2241,
	"assets/shop/caramel-slices-tuttifrutti.jpg": 7583,
	"assets/shop/caramel-slices-walnut.jpg": 1738,
	"assets/shop/caramel-tray.jpg": 801,
	"assets/shop/plain-board.jpg": 7414,
	"assets/shop/plain-cocoa-foil.jpg": 8692,
	"assets/shop/plain-cocoa-loaf.jpg": 1216,
	"assets/shop/plain-cocoa-slices-cherry.jpg": 4549,
	"assets/shop/plain-cocoa-slices-kaju.jpg": 1677,
	"assets/shop/plain-cocoa-slices-kismis.jpg": 7670,
	"assets/shop/plain-cocoa-slices-mixed.jpg": 8629,
	"assets/shop/plain-cocoa-slices-none.jpg": 5787,
	"assets/shop/plain-cocoa-slices-tuttifrutti.jpg": 4920,
	"assets/shop/plain-cocoa-slices-walnut.jpg": 2919,
	"assets/shop/plain-foil.jpg": 1354,
	"assets/shop/plain-loaf.jpg": 4305,
	"assets/shop/plain-slices-cherry.jpg": 2911,
	"assets/shop/plain-slices-kaju.jpg": 6043,
	"assets/shop/plain-slices-kismis.jpg": 3256,
	"assets/shop/plain-slices-mixed.jpg": 8239,
	"assets/shop/plain-slices-none.jpg": 3954,
	"assets/shop/plain-slices-tuttifrutti.jpg": 4090,
	"assets/shop/plain-slices-walnut.jpg": 6957,
	"assets/shop/plain-tray.jpg": 552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2920;